import { render, staticRenderFns } from "./CarQueue.vue?vue&type=template&id=4674bbfe"
import script from "./CarQueue.vue?vue&type=script&lang=js"
export * from "./CarQueue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports